/**
 * Stone Investment Property Gallery
 *
 * Stone-themed wrapper for the core PropertyGallery component.
 * Applies square corners and greyscale aesthetic.
 */

'use client';

import { PropertyGallery, type PropertyGalleryProps } from '@/components/properties';

export type StonePropertyGalleryProps = PropertyGalleryProps;

export function StonePropertyGallery(props: PropertyGalleryProps) {
  return (
    <div
      className="
        relative
        font-['Montserrat',-apple-system,BlinkMacSystemFont,'Segoe_UI',sans-serif]
        **:rounded-none
      "
    >
      <PropertyGallery {...props} className="" />
    </div>
  );
}
